// @ai-generated 2026-08-28T07:59:23+00:00 by matthias.gessinger@synqony.com using Claude Opus 5 (1M context)
import { EnumMessageLevel } from '@synqo/frontend-component-library';

const LABELS_BY_LEVEL: Record<EnumMessageLevel, { one: string; many: string }> = {
    [EnumMessageLevel.Danger]: { one: 'Fehler', many: 'Fehler' },
    [EnumMessageLevel.Warning]: { one: 'Warnung', many: 'Warnungen' },
    [EnumMessageLevel.Information]: { one: 'Hinweis', many: 'Hinweise' },
    [EnumMessageLevel.Success]: { one: 'Erfolgsmeldung', many: 'Erfolgsmeldungen' },
    [EnumMessageLevel.NotDefined]: { one: 'Meldung', many: 'Meldungen' },
};

/**
 * How many messages of a level there are, as the phrase a person reads: "1 Warnung", "3 Fehler".
 * The count is what makes a level worth naming, so the two are never formatted apart.
 */
export function describeMessageLevelCount(level: EnumMessageLevel, count: number): string {
    const labels = LABELS_BY_LEVEL[level] ?? LABELS_BY_LEVEL[EnumMessageLevel.NotDefined];
    return `${count} ${count === 1 ? labels.one : labels.many}`;
}
